<div *ngIf="appState | async as appState" class="flex justify-between items-center footer-bg">
  <button matTooltip="Get help" mat-icon-button (click)="openFAQ()">
    <mat-icon class="text-white">help</mat-icon>
  </button>
  <span class="grow"></span>
  <button
    *ngIf="checkVersionEnabled(appState)"
    matTooltip="Recheck browser version"
    mat-icon-button
    (click)="recheckBrowserVersion()"
  >
    <mat-icon class="text-white">browser_updated</mat-icon>
  </button>
  <button matTooltip="Reload extension" mat-icon-button (click)="reloadExtension()">
    <mat-icon class="text-white">restart_alt</mat-icon>
  </button>
  <!-- Disabled for Now Maybe have a use case later -->
  <!-- <button matTooltip="Resync extension" mat-icon-button (click)="resyncExtension()" [disabled]="appSyncing">    
    <mat-icon class="text-white">cloud_sync</mat-icon>
  </button> -->
</div>
